import { Search } from '@shinetools/lumen-react'
import { ReactElement, useCallback } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import { useDebouncedSearchInput } from '../../../../../../../../hooks/useDebouncedSearchInput'
import * as Styled from './styles'

interface LedgerEntriesSearchProps {
  ledgerSearchQuery?: string
  onSearchChange: (ledgerSearchQuery?: string) => void
}

export const LedgerEntriesSearch = ({ ledgerSearchQuery, onSearchChange }: LedgerEntriesSearchProps): ReactElement => {
  const { bt } = useBalanceLabels()

  const handleSearchUpdate = useCallback(
    (value: string) => {
      onSearchChange(value || undefined)
    },
    [onSearchChange],
  )

  const { onChange: handleChange, value } = useDebouncedSearchInput(ledgerSearchQuery, handleSearchUpdate)

  return (
    <Styled.SearchWrapper>
      <Search
        rounded
        noDropdown
        onChange={handleChange}
        placeholder={bt('detail_view.search.placeholder')}
        size="small"
        value={value}
      />
    </Styled.SearchWrapper>
  )
}
